export default __webpack_public_path__ + "static/media/logo1.76c6b2e8.png";